import React from 'react'
import { Box } from '@plvs/respawn/features/layout'
import { NxAvatar, NxTypography } from '@playvs-inc/nexus-components'
import { useTheme } from '@material-ui/core'
import { defaultToEmptyString } from '@plvs/utils'
import { MatchOverlayTeam } from '@plvs/respawn/features/overlay/useMatchOverlay'

const AVATAR_SIZE = 30

type ScoreOverlayTeamClusterProps = {
  team: MatchOverlayTeam
  avatarPosition?: 'left' | 'right'
  bgColor?: string
}

export const ScoreOverlayTeamCluster: React.FC<
  ScoreOverlayTeamClusterProps
> = ({ team, bgColor, avatarPosition = 'right' }) => {
  const theme = useTheme()
  const avatar = (
    <NxAvatar
      avatarHashId={defaultToEmptyString(team?.id)}
      avatarUrl={defaultToEmptyString(team?.avatarUrl)}
      height={AVATAR_SIZE}
      width={AVATAR_SIZE}
    />
  )

  return (
    <Box
      bgcolor={bgColor}
      borderColor={theme.palette.common.black}
      borderRadius={theme.mixins.cornerRadius['border-radius-8']}
      gridGap={theme.spacing(0.5)}
      p={2}
    >
      <Box alignItems="center" display="flex" gridGap={theme.spacing(1)}>
        {avatarPosition === 'left' ? avatar : null}
        <NxTypography variant="h3">{team?.name}</NxTypography>
        {avatarPosition === 'right' ? avatar : null}
      </Box>
      <NxTypography variant="h4">{team?.school?.name}</NxTypography>
    </Box>
  )
}
